export default {
  /**
   * http配置参数
   */
  // baseURL: 'http://192.168.3.11:3100', // 本地
  baseURL: 'https://tongjiht.huamengbi.cn', // 线上-主
  timeout: 6000
}



// WEBPACK FOOTER //
// ./src/http/httpConfig.js